import { useAuthStore } from '../store/auth-store.js';
import type { V1RoleName } from '@laxmi-ai/shared';

export function useV1Role() {
  const v1Role = useAuthStore((s) => s.user?.v1Role ?? null) as V1RoleName | null;

  const isAgencyOwner = v1Role === 'AGENCY_OWNER';
  const isAccountManager = v1Role === 'ACCOUNT_MANAGER';
  const isContentManager = v1Role === 'CONTENT_MANAGER';
  const isCreator = v1Role === 'CREATOR';
  const isViewer = v1Role === 'VIEWER';

  const isAdminLike = isAgencyOwner || isAccountManager;

  return {
    v1Role,
    isAgencyOwner,
    isAccountManager,
    isContentManager,
    isCreator,
    isViewer,
    isAdminLike,
  };
}
